import type { CompanyType } from '@/types/Activity'

export const isNonProfitOrganisation = (companyType: CompanyType) => {
  const charitableOrganisationTypes: CompanyType[] = [
    'CharitableIncorporatedOrganisation',
    'CooperativeAndCommunityBenefitSocietyWithCharitableStatus',
    'PrivateLimitedCompanyByGuaranteeWithoutShareCapital',
    'PrivateLimitedCompanyByGuaranteeWithoutShareCapitalUseOfLimitedExemption',
  ]

  return charitableOrganisationTypes.includes(companyType)
}
